export default {
  form: {
    details: {
      title: "Questionnaire Details",
      name: "Questionnaire name",
      namePlaceholder: "Enter the questionnaire name",
      tag: "Tag",
      collectors: "Select surveyors",
      selectedCollectors: "Selected surveyors",
      description: "Description",
      descriptionPlaceholder: "Enter a description",
      titleManagement: "Pages Management",
      pageTitle: "Page title",
      hintUser: "User hint",
      page: "Page",
      label: "Label",
      hint: "Hint",
      relation: "Relation",
      titleField: "Title",
      after: "After",
      formContent: "Questionnaire content",
      selectWidget: "Select a widget",
    },
    tags: {
      demandForecast: "Demand forecast",
      clientAddressing: "Client addressing",
      geolocation: "Geolocation",
    },
    settings: {
      allowMapGps: "Allow GPS position via map",
      allowGalleryPicture: "Allow adding photos from gallery",
      allowBeforeAnswer: "Allow retrieving responses from the previous survey"
    },
    index: {
      deleteTitle: "Delete",
      deleteBody: "Are you sure you want to delete this form? (Surveys linked to this questionnaire will be deleted)",
      confirmTitle: "Confirm",
      saveBody: "Save as:",
      importBody: "Drop the file to import:",
      enterName: "Enter a name",
      noForm: "No form",
      tagFilter: "Questionnaire tag",
      all: "All",
      dateFrom: "Date from",
      dateTo: "to",
      table: {
        name: "Questionnaire name",
        status: "Status",
        updatedAt: "Modified",
        tag: "Tag",
        nbEnquetes: "No. of surveys"
      },
      inactive: "Inactive",
      active: "Active",
      activate: "Activate questionnaire",
      deactivate: "Deactivate questionnaire",
      unlock: "Unlock",
      lock: "Lock",
      detail: "View details",
      enquetes: "View surveys",
      exportXLS: "Export XLSForm",
      duplicateXLS: "Duplicate"
    },
    widget: {
      calcul: "Calculation:",
      calculPlaceholder: "Write your calculation here...",
      constraintMessage: "Constraint message",
      constraints: "Constraints",
      decimal: "Decimal",
      delete: "Delete",
      imageTitle: "Image title",
      interval: "Interval",
      lengthMinMax: "Min/Max length",
      min: "Min",
      max: "Max",
      mode: "Input mode",
      notePlaceholder: "Write your message here...",
      noteToKnow: "Note to know:",
      noteTitle: "Note title",
      possibleAnswer: "Possible answer",
      question: "Question",
      regex: "Regex",
      regexPlaceholder: "Ex: [A-Za-z0-9]",
      response: "Response",
      responseType: "Response type",
      default: "Default",
      defaultValue: "Default value",
      value: "Value",
      operator: "Operator",
      geolocationTitle: "Geolocation title",
      hint: "Hint",
      position: "Position",
      editQuestion: "Edit question",
      editQuestionTitle: "Click to edit the question",
      startQuestionTitle: "Start of the question",
      requis: "Required",
      page: "Page",
      pagePlaceholder: "Enter the page",
      moveUpTitle: "Move question up",
      moveUp: "Move question up",
      moveDown: "Move question down",
      moveDownTitle: "Move question down",
      deleteTitle: "Delete question",
      settingTitle: "Questionnaire settings",
      pertinence: "Relevance",
      strictInferieurA: "Strictly less than",
      strictSuperieurA: "Strictly greater than",
      inferieurA: "Less than",
      superieurEgalA: "Greater than or equal to",
      strictSuperieurA: "Strictly greater than",
      reponse: "Response",
      entierPositif: "Positive integer",
      siLaReponseEst: "If the answer is",
      reponses: "Answers",
      incluses: "Included",
      excluses: "Excluded",
      repetition: "Repetition",
      definirRepetition: "Define a repetition",
      modifierRepetition: "Edit repetition",
      utiliserValeurFixe: "Use a fixed value",
      utiliserCalcul: "Use a calculation",
      fois: "times",
      actif: "Active",
      chooseAppearance: "Choose appearance",
      chooseAppearanceAttribute: "Choose an appearance attribute",
      dateType: "Date",
      enableConstraints: "Enable constraints",
      loadingPreviousWidgets: "Loading previous widgets...",
      loadingNextWidgets: "Loading next widgets..."
    },
    enquete: {
      title: "Results of {count} surveys for: {formName}",
      modal: {
        responsesTitle: "Survey #{id} responses",
        dispatchTitle: "Set responses processing - Settings table",
        deleteTitle: "Delete",
        deleteBody: "Are you sure you want to delete this survey?"
      },
      table: {
        id: "ID",
        question: "Question",
        response: "Response",
        headers: {
          number: "#",
          enqueteId: "Survey ID",
          date: "Date",
          location: "Location",
          name: "Last name",
          firstname: "First name",
          email: "Email",
          actions: "Actions"
        },
        noData: "No surveys found."
      },
      buttons: {
        close: "Close",
        delete: "Delete",
        send: "Send responses",
        sending: "Sending...",
        export: "Export Excel",
        dispatch: "Process Responses",
        seeResponses: "See responses",
        clear: "Clear"
      },
      filters: {
        searchPlaceholder: "Search id, last name, first name, email...",
        dateFrom: "Date from:",
        dateTo: "to:"
      },
      mapping: {
        title: "Map fields to questions",
        fieldQuestion: "Associated question",
        chooseQuestion: "Choose a question",
        tabs: {
          client: "Client",
          placeCompteur: "Counter slot",
          compteur: "Counter"
        },
        fields: {
          customer: {
            nom: "Last name",
            prenom: "First name",
            tel_1: "Phone 1",
            tel_2: "Phone 2",
            raisonSocial: "Company name",
            nomSignature: "Signature name",
            signature: "Signature",
            isValide: "Valid",
            isActive: "Active"
          },
          placeCompteur: {
            villagesNeighborhood: "Village/Neighborhood",
            posGPS: "GPS position"
          },
          compteur: {
            compteur: "Counter"
          }
        }
      }
    },
  },
}
